// assets/js/components/revenue-calculator/steps/step-4.js
var ui = require("../ui");
var validate = require("../validate");

function render(state) {
    var d = state.d;
    var nsPlaceholder = _t("e.g. %n%").replace("%n%", String(Math.max(1, Math.round((Number(d.bookingsMonth) > 0 ? Number(d.bookingsMonth) : 30) * 0.10))));

    var html = ui.stepLabel(_t("Step 4 of 6")) + ui.h2(_t("Where revenue may be leaking")) +
        ui.sub(_t("If you're unsure, use your best estimate."));

    html += ui.field({
        id: "rc-no-shows-month", label: _t("How many no-shows do you usually get per month?"), required: true,
        hint: _t("Approximate number per month, not a percentage."),
        inner: ui.textInput({ id: "rc-no-shows-month", type: "number", value: d.noShowsMonth, placeholder: nsPlaceholder, min: 0 })
    });
    html += ui.field({
        id: "rc-empty-hours", label: _t("About how many bookable hours stay empty in a typical week?"), required: true,
        inner: ui.textInput({ id: "rc-empty-hours", type: "number", value: d.emptyHours, placeholder: _t("e.g. 8"), min: 0 })
    });
    html += ui.field({
        id: "rc-cancelations", label: _t("How many last-minute cancellations do you usually get per month?"), required: true,
        inner: ui.textInput({ id: "rc-cancelations", type: "number", value: d.cancelations, placeholder: _t("e.g. 5"), min: 0 })
    });
    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    container.querySelector("#rc-no-shows-month").addEventListener("input", function (e) { actions.setField("noShowsMonth", e.target.value); });
    container.querySelector("#rc-empty-hours").addEventListener("input", function (e) { actions.setField("emptyHours", e.target.value); });
    container.querySelector("#rc-cancelations").addEventListener("input", function (e) { actions.setField("cancelations", e.target.value); });

    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        var numErr = validate.firstNumberError(d, [
            { key: "noShowsMonth", id: "rc-no-shows-month", min: 0, max: 1000000, integer: true },
            { key: "emptyHours", id: "rc-empty-hours", min: 0, max: 1000 },
            { key: "cancelations", id: "rc-cancelations", min: 0, max: 1000000, integer: true }
        ]);
        if (numErr) {
            actions.showError(numErr.id, numErr.message);
            return;
        }
        state.step = 5;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
